import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import EmployeeForm from './EmployeeForm'

import { updateEmployee } from '../services'
import { handleError } from '../../../helpers'

export default function EditEmployeeModal({ visible, onClose, employee, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm({ defaultValues: employee })
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		if(employee.email === values.email) delete values.email
		updateEmployee(employee.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<EmployeeForm 
						register={register}
						errors={errors}
						editable
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}